import request from '@/utils/request';
const { VUE_APP_LAOSHIBANG } = process.env;

export function modUserInfo(code) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/user/mod',
    method: 'post',
    data: { ...code }
  });
}

export function getUserInfo(code) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/user/info',
    method: 'post',
    data: { code }
  });
}

// 提交举报
export function submitReport(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/report',
    method: 'post',
    data
  });
}
